/**
 * Test if we are currently in dev mode.
 * @return {Boolean}
 */
export function isDev() {
  return !['em-strasbourg.eu', 'www.em-strasbourg.eu'].includes(window.location.hostname);
}

/**
 * Use the global Drupal object.
 * @return {Object}
 */
export function useDrupal() {
  return window.Drupal || {};
}

/**
 * Use the global drupalSettings object.
 * @return {Object}
 */
export function useDrupalSettings() {
  return window.drupalSettings || {};
}

/**
 * Active breakpoints for the burger menu.
 * @type {String}
 */
export const MENU_BURGER_BREAKPOINTS = 'xxs xs s m';
